<template>
	<div class="justify-center d-block pa-3 pa-md-6 pa-lg-12">
		<h1 class="display-1 mb-2" v-html="titre"></h1>
		<p class="body-1" v-html="message">
		</p>
	</div>
</template>

<script>
	export default {
		props: {
			titre: {
				type: String,
				default: "Votre demande d'inscription a bien été enregistrée."
			},
			message: {
				type: String,
				default: ""
			}
		},
	}
</script>